import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApplicationInsightsService } from '../services/application-insights.service';
import { ErrorLogHandler } from './httpdata.service';

@Injectable()
export class ApplicationInsightsErrorHandler implements ErrorHandler, ErrorLogHandler {
    constructor(private appInsightService: ApplicationInsightsService, private router: Router) {}

    handleError(error: any): void {
        const props = {url: this.router.url};
        console.error(error);   
        this.appInsightService.logException(error, props);
    }

    logError(error: HttpErrorResponse, url?: string, data?: unknown): void {
        let jsonData: string = null;
        if(data != null) {
            try{
                jsonData = JSON.stringify(data);
            } catch(ex) {
                this.appInsightService.logException(error);
            }
        }

        const props = {url: url, data: jsonData};
        this.appInsightService.logException(error, props);
    }
}
